import * as constants from "./constants";
import * as g_constants from '../global/constants';

const initialState = {
  bookings: [],
  listings: [],
  users: []
};

export default function Global(state = initialState, action) {
  switch (action.type) {
    case constants.SET_ADMIN_BOOKINGS_LIST:
      return Object.assign({}, state, {
        bookings: action.data
      });
    case constants.SET_ADMIN_LISTINGS_LIST:
      return Object.assign({}, state, {
        listings: action.data
      });
    case "DASHBOARD_SET_LISTING": //this comes from a separate set of constants
      //console.log("setting Listing");
      if (!state.listings.length) return state;
      let indexOfId = state.listings.map(l => l._id).indexOf(action.data._id);
      if (indexOfId > -1) {
        state.listings.splice(indexOfId, 1, action.data);
      }
      return Object.assign({}, state, {
        listings: state.listings.slice(0)
      });
    case constants.SET_ADMIN_USERS_LIST:
      return Object.assign({}, state, {
        users: action.data
      });
    case g_constants.LOGOUT:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
